module.exports = __webpack_public_path__ + "static/media/SackersGothicStd-Heavy.72662e18.otf";